import React from 'react';
import { connect } from 'react-redux';
import Link from 'redux-first-router-link';
import Newsletter from './Newsletter';
import { goToPage } from '../../actions/environment';
import APLACElogo from '../Header/aplace-new-logo-black.svg';
import { translate, prefix } from '../../utils/string';
import s from './Footer.scss';

const Footer = ({ properties, setup, footer, navigation }) => {
	if (properties.siteInitiated === false || properties.siteClosed === true) return null;

	// const magazineUri = translateObjectDefaultData(setup, magazine.posts[0].meta);

	return (
		<div className={s.pageEnd}>
			<div className={s.footer}>
				<nav className={s.footer_menu}>
					{
						navigation.footer && navigation.footer.map((menu, i) => (
							<div className={s.footer_menu_column} key={translate(setup, menu, 'title')}>
								<Link className={s.footer_menu_column_headline} to={prefix(setup, translate(setup, menu, 'uri'))}><h5>{ translate(setup, menu, 'title') }</h5></Link>
								{
									menu.subPages && menu.subPages.map((link) => (
										<Link className={s.footer_menu_column_link} key={translate(setup, link, 'title')} to={prefix(setup, translate(setup, link, 'uri'))}>{ translate(setup, link, 'title') }</Link>
									))
								}
							</div>
						))
					}
				</nav>
				<div className={s.footer_newsletter}>
					<h5 className={s.footer_newsletter_header}>{translate(setup, footer.signUpText)}</h5>
					<Newsletter />
				</div>
				<Link className={s.footer_logo} to={prefix(setup, '')} aria-label="Go to homepage">
					<img src={APLACElogo} alt="APLACE" />
				</Link>
				<span className={s.footer_organisation}>{translate(setup, footer.organisationInfo)}</span>
			</div>
		</div>
	);
};

const mapState = ({ environment }) => {
	const { properties, setup, footer, navigation } = environment;
	return { properties, setup, footer, navigation };
};

export default connect(mapState, { goToPage })(Footer);
